import { Navigate, useRouteError } from "react-router-dom";

import { getNextFromPath } from "@/hooks/useNextParam";
import { AppError } from "@/utils/errors";

export const AppErrorBoundary = () => {
  const error = useRouteError();

  if (error instanceof AppError) {
    const nextParam = getNextFromPath(
      `${window.location.pathname}${window.location.search}${window.location.hash}`,
    );
    return <Navigate to={`/error?code=${error.code}&next=${nextParam}`} />;
  }

  throw error; // bubble up to the nearest error boundary
};
